import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors, sizes, width, media } from 'styles/variables';
import RichText from 'utils/RichText';
import { clock } from 'styles/vectors';

export default props => {
	const [order] = useState(require(`data/order`));
	const [time] = useState(
		typeof localStorage !== 'undefined' && localStorage.getItem('time')
			? JSON.parse(localStorage.getItem('time'))
			: new Date().getTime() + order.timer_seconds * 1000,
	);
	typeof localStorage !== 'undefined' && localStorage.setItem('time', time);
	const [timeLeft, setTimeLeft] = useState(time - new Date().getTime());

	useEffect(() => {
		const interval = setInterval(() => {
			const newTime = time - new Date().getTime();
			if (newTime < 0) {
				clearInterval(interval);
			} else {
				setTimeLeft(newTime);
			}
		}, 1000);
		return () => clearInterval(interval);
	});

	const StyledWrapper = styled.div`
		width: 100%;
		padding: ${sizes[2]};
		background: ${colors.pink.base};
		color: ${colors.background[0]};
		text-align: center;
		display: grid;
		${media.notsmall} {
			grid-template-columns: auto 1fr auto;
		}
		${media.small} {
			grid-template-columns: auto 1fr;
			grid-template-rows: auto auto;
			border-radius: 0;
		}
		grid-gap: ${sizes[2]};
		align-items: center;
		svg {
			.fill1 {
				fill: ${colors.background[0]};
			}
		}
	`;

	const Text = styled.div`
		text-align: left;
		font-weight: bold;
		* {
			color: ${colors.background[0]};
			line-height: 125%;
			margin: 0 !important;
			padding: 0 !important;
		}
		em {
			font-size: 0.8rem !important;
		}
		h1 {
			font-size: 1.25rem !important;
		}
	`;

	const Time = styled.div`
		font-size: 2rem !important;
		font-weight: bold;
		display: block;
		text-align: center;
		${media.small} {
			grid-column: span 2;
			font-size: 2rem !important;
		}
	`;

	let timerAll = Math.max(Math.floor(timeLeft / 1000), 0);
	let timerHours = Math.floor(timerAll / 60 / 60);
	let timerMinutes = Math.floor((timerAll - timerHours * 60 * 60) / 60);
	let timerSeconds = Math.floor(timerAll - timerHours * 60 * 60 - timerMinutes * 60);
	timerHours = ('0' + timerHours).slice(-2);
	timerMinutes = ('0' + timerMinutes).slice(-2);
	timerSeconds = ('0' + timerSeconds).slice(-2);
	return (
		<StyledWrapper>
			{clock}
			<Text>
				<RichText data={order.timer_title} />
			</Text>
			<Time>
				{timerHours}:{timerMinutes}:{timerSeconds}
			</Time>
		</StyledWrapper>
	);
};
